import { Fragment } from 'react';

import { Button } from 'primereact/button';

import { TenantClientService as Service, TenantClientService } from './TenantClientService';

import { ToastService } from '../../../AppToast';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { useImExExcel } from '../../../shared/hooks/ImExExcel';
import { AppStorage } from '../../../service/UserStorage';
export const List = () => {

  const header = 'Khách hàng';
  const dataKey = 'id';

  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'code', header: 'Mã khách hàng', width: 160, matchMode: 'contains' },
      { field: 'personContact', header: 'Người mua hàng', width: 160, matchMode: 'contains' },
      { field: 'identificationCard', header: 'CCCD/CMND', width: 160, matchMode: 'contains' },
      { field: 'name', header: 'Tên đơn vị', minWidth: 220, matchMode: 'contains' },
      { field: 'taxCode', header: 'Mã số thuế', width: 160, matchMode: 'contains' },


      { field: 'address', header: 'Địa chỉ', minWidth: 160, matchMode: 'contains' },
      { field: 'mobile', header: 'Điện thoại', width: 160, matchMode: 'contains' },
      { field: 'email', header: 'Email', width: 160, matchMode: 'contains' },
      { field: 'bankAccount', header: 'Số tài khoản', width: 160, matchMode: 'contains' },
      { field: 'bankName', header: 'Tên ngân hàng', width: 160, matchMode: 'contains' },
      // { field: 'hasAccount', header: 'Đã tạo tài khoản', width: 180, matchMode: 'equals', filterType: 'boolean', dataType: 'boolean' },
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const handleSearchTaxCode = () => {
    const { taxCode, code } = getValue();
    if (taxCode) {
      TenantClientService.searchTaxCode(taxCode).then(data => {
        if (data) {
          setValue({
            ...getValue(),
            code: data.code || '',
            taxCode: data.taxCode || '',
            name: data.name || '',
            personContact: data.personContact || '',
            address: data.address || ''
          });
        } else {
          ToastService.error('Không tìm thấy dữ liệu');
        }
      });
    }
  }

  const handleSearchIdentity = () => {
    const { identificationCard } = getValue();
    if (identificationCard) {
      TenantClientService.searchIdentityCar(identificationCard).then(data => {
        if (data) {
          setValue({
            ...getValue(),
            personContact: data.name || '',
          });
        } else {
          ToastService.error('Không tìm thấy dữ liệu');
        }
      });
    }
  }

  const { render: renderDialogCrup, create, update, clone, getValue, setValue } = useDialogCrup({
    header,
    dataKey,
    width: '60rem',
    fields: [
      { field: 'code', header: 'Mã khách hàng', required: true, uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'identificationCard', header: 'CCCD', InputTextProps: { maxLength: 12, }, className: 'md:col-5' },
      {
        type: 'custom', className: 'md:col-1', body: (
          <div className="mt-4">
            <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={handleSearchIdentity} />
          </div>
        )
      },
      { field: 'personContact', header: 'Người mua hàng', InputTextProps: { maxLength: 100 }, className: 'md:col-6' },
      { field: 'taxCode', header: 'Mã số thuế', InputTextProps: { maxLength: 14, validator: 'taxCode' }, className: 'md:col-5' },
      {
        type: 'custom', className: 'md:col-1', body: (
          <div className="mt-4">
            <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={handleSearchTaxCode} />
          </div>
        )
      },
      { field: 'name', header: 'Tên đơn vị', InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'address', header: 'Địa chỉ', InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'email', header: 'Email, Email găn cách bởi dấu , hoặc ; ', InputTextProps: { maxLength: 250 }, className: 'md:col-6' },
      { field: 'mobile', header: 'Điện thoại', InputTextProps: { maxLength: 20 }, className: 'md:col-6' },
      { field: 'bankAccount', header: 'Số tài khoản', InputTextProps: { maxLength: 30 }, className: 'md:col-5' },
      { field: 'bankName', header: 'Tên ngân hàng', InputTextProps: { maxLength: 400 }, className: 'md:col-7' }
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const { render: renderDialogCrupUser, update: crupUser } = useDialogCrup({
    header: '!Tạo tài khoản tra cứu hóa đơn',
    dataKey,
    width: '45rem',
    fields: [
      { field: 'name', header: 'Tên khách hàng', disabled: true, className: 'md:col-12' },
      { field: 'taxCode', header: 'Mã số thuế', disabled: true, className: 'md:col-12' },
      { field: 'code', header: 'Mã khách hàng', disabled: true, className: 'md:col-12' },
      { field: 'userName', header: 'Tên truy cập', className: 'md:col-12' },
      { field: 'password', header: 'Mật khẩu', type: "Password", InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'email', header: 'Email', InputTextProps: { maxLength: 400 }, className: 'md:col-12' }
    ],
    updateItem: (id, item) => {

      if (item.hasAccount === true) {
        ToastService.error('Chưa chọn khách hàng');
        return;
      }
      let accountInfo = {
        id,
        taxCode: AppStorage.get('tenantName'),
        customerCode: item.code,
        userName: item.userName,
        password: item.password,
        email: item.email,
        appVersion: 2,
      };
      return Service.createAcccountSearch(accountInfo);
    },
    refreshLazyData
  });

  const { renderImExExcel, download, showImportDialog } = useImExExcel({
    exportTemplate: () => {
      return Service.downloadExcelTemplate();
    },
    exportExcel: (params) => {
      return Service.downloadExcel(params);
    },
    exportExcelFileName: 'danh-muc-khach-hang',
    importExcel: (data) => {
      return Service.uploadExcel(data);
    },
    reloadLazyData
  });

  const showCrupUser = () => {
    if (selectedItems?.['id']) {
      crupUser(selectedItems);
    } else {
      ToastService.error('Chưa chọn khách hàng');
    }
  }

  const { renderToolbar } = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    showImportDialog,
    exportExcel: download, dataTableParams,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: []
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      {renderDialogCrupUser()}
      {renderImExExcel()}
    </Fragment>
  )
}
